import React from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

// Check environment
const isDev = true;

function Header() {
  return (
    <Navbar variant="dark" expand="lg" className="mb-3 bg-dark">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            src="/images/estyn-logo-white.svg"
            height="30"
            className="d-inline-block align-top me-2"
            alt="Estyn Logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {/* Conditional Links for Development */}
            {isDev && (
              <>
                <Nav.Link as={Link} to="/analytics">
                  Analytics Dashboard
                </Nav.Link>
              </>
            )}
            {/* Always Visible Link */}
            <Nav.Link as={Link} to="/redact">
              Data Redaction
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
